import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { formatPrice } from '../utils/formatPrice';
import { Product, ProductAddon, OrderProductAddon } from '../interfaces';

interface AddAddonsPopupProps {
    product: Product;
    onClose: () => void;
    onNext: (selectedAddons: OrderProductAddon[]) => void;
}


const AddAddonsPopup: React.FC<AddAddonsPopupProps> = ({ product, onClose, onNext }) => {
    const [selectedAddons, setSelectedAddons] = useState<OrderProductAddon[]>([]);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });

    useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);

   
      useEffect(() => {
        const handleResize = () => {
            console.log("onresize: innerWidth: " + window.innerWidth + "innerHeight: " + innerHeight)
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };
    
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const updateSize = () => {
            console.log("update size")
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
    
        window.addEventListener("resize", updateSize);
        window.addEventListener("focus", updateSize);
        document.addEventListener("visibilitychange", updateSize);
    
        return () => {
            window.removeEventListener("resize", updateSize);
            window.removeEventListener("focus", updateSize);
            document.removeEventListener("visibilitychange", updateSize);
        };
    }, []);


    const handleSelectAddon = (addon: ProductAddon) => {
        setSelectedAddons(prevState => {
            const addonExists = prevState.find(a => a.addon.id === addon.id);
            if (addonExists) {
                return prevState;
            }
            return [...prevState, { addon, qty: 1, addonId: addon.id, addonName: addon.name, price: addon.priceWithoutTax }];
        });
    };

    const handleIncrement = (addon: ProductAddon) => {
        setSelectedAddons(prevState =>
            prevState.map(a =>
                a.addon.id === addon.id ? { ...a, qty: a.qty + 1 } : a
            )
        );
    };

    const handleDecrement = (addon: ProductAddon) => {
        setSelectedAddons(prevState =>
            prevState
                .map(a =>
                    a.addon.id === addon.id ? { ...a, qty: a.qty > 1 ? a.qty - 1 : 1 } : a
                )
                .filter(a => a.qty > 0)
        );
    };

    const handleRemoveAddon = (addon: ProductAddon) => {
        setSelectedAddons(prevState => prevState.filter(a => a.addon.id !== addon.id));
    };

    const handleNext = () => {
        onNext(selectedAddons)
    }

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1001,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
    });

    return (
        <div style={styles.popup} className='ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-end'>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>
            <div className='px-4 pb-3'>
                <h5>Add Addon</h5>
                {product.addons.map(addon => {
                    const selectedAddon = selectedAddons.find(a => a.addon.id === addon.id);
                    return (
                        <div key={addon.id} className='border-box p-2 mt-2 d-flex justify-content-between align-items-center'>
                            <label style={{fontWeight: '500', fontSize: '14px'}} className='d-flex align-items-center'>{addon.name}</label>
                            <div className='d-flex gap-2 align-items-center'>
                                <label style={{fontWeight: '600', fontSize: '14px', color: '#17B26A'}}>+{formatPrice(addon.priceWithoutTax)}</label>
                                {selectedAddon ? (
                                    <div className="d-flex px-1 align-items-center"
                                        style={{
                                            border: '1px solid lightgrey',
                                            borderRadius: '20px',
                                            height: '36px',
                                            overflow: 'hidden',
                                            transition: 'width 0.5s ease-in-out',
                                        }}>
                                        {selectedAddon.qty === 1 ? (
                                            <button className="d-flex justify-content-center align-items-center"
                                                onClick={() => handleRemoveAddon(addon)}
                                                style={{
                                                    borderRadius: '20px',
                                                    height: '30px',
                                                    width: '30px',
                                                    borderWidth: '0',
                                                    backgroundColor: 'rgb(244, 244, 244)',
                                                }}>
                                                <svg width="15" height="15" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M12.3333 4.99935V4.33268C12.3333 3.39926 12.3333 2.93255 12.1517 2.57603C11.9919 2.26243 11.7369 2.00746 11.4233 1.84767C11.0668 1.66602 10.6001 1.66602 9.66667 1.66602H8.33333C7.39991 1.66602 6.9332 1.66602 6.57668 1.84767C6.26308 2.00746 6.00811 2.26243 5.84832 2.57603C5.66667 2.93255 5.66667 3.39926 5.66667 4.33268V4.99935M7.33333 9.58268V13.7493M10.6667 9.58268V13.7493M1.5 4.99935H16.5M14.8333 4.99935V14.3327C14.8333 15.7328 14.8333 16.4329 14.5608 16.9677C14.3212 17.4381 13.9387 17.8205 13.4683 18.0602C12.9335 18.3327 12.2335 18.3327 10.8333 18.3327H7.16667C5.76654 18.3327 5.06647 18.3327 4.53169 18.0602C4.06129 17.8205 3.67883 17.4381 3.43915 16.9677C3.16667 16.4329 3.16667 15.7328 3.16667 14.3327V4.99935"
                                                        stroke="#475467"
                                                        strokeWidth="1.66667"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </button>
                                        ) : (
                                            <button className="d-flex justify-content-center align-items-center"
                                                style={{
                                                    borderRadius: '20px',
                                                    height: '30px',
                                                    width: '30px',
                                                    borderWidth: '0',
                                                    backgroundColor: 'rgb(244, 244, 244)',
                                                }} onClick={() => handleDecrement(addon)}>
                                                <svg width="12" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 1H15" stroke="#475467" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button>
                                        )}
                                        <span className='mx-2'>{selectedAddon.qty}</span>
                                        <button className="d-flex justify-content-center align-items-center"
                                            onClick={() => handleIncrement(addon)}
                                            style={{
                                                borderRadius: '20px',
                                                height: '30px',
                                                width: '30px',
                                                borderWidth: '0',
                                                backgroundColor: 'rgb(244, 244, 244)',
                                            }}>
                                            <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7.00033 1.16602V12.8327M1.16699 6.99935H12.8337"
                                                    stroke="#475467"
                                                    strokeWidth="1.66667"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                ) : (
                                    <button className='blue-filled-btn' onClick={() => handleSelectAddon(addon)}>Select</button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className='p-2 d-flex justify-content-end' style={{ backgroundColor: '#F3F4F6' }}>
                <button className='white-filled-btn' onClick={handleNext}>Next</button>
            </div>
        </div>
    );
};




export default AddAddonsPopup;

